export const PNG_WIDTH = 510;
export const PNG_HEIGHT = 153;

export const IMAGE_FACTOR = 1.5;
